/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Past/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'



/** @type {import('Simple/types.js').View} */
export default function Past({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Appointments/Tabs/Past"
  
}) {
let appointmentsTabValueData = fromData.useDataValue({ viewPath,
context: 'appointments',
path: 'tab',
})
let constantData = 'past'
let aggregateData = fromAggregate.equals(appointmentsTabValueData, constantData)
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 size="normal"
 color={dtColorsBlack}
 text="Past Appointments"
 onClick={onClick}
 data="appointments.tab"
 data="'past'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
/>
{children}
</React.Fragment>)
}